import { forWeb } from '@ff-os/shared-utils/asset-urls';
import { isBlobUrl } from '@ff-os/shared-utils/is-blob-url';
import { isDescriptor } from '@ff-os/shared-utils/private-urls';
import { loadDOMImage } from 'ff-canvas';
import { privateImageCache } from './privateImageCache';

export const loadImage = async (url: string, language: string) => {
    if (isDescriptor(url)) {
        return loadPrivateImage(url);
    } else if (isBlobUrl(url)) {
        return loadDOMImage(url, 'anonymous');
    } else {
        return loadDOMImage(forWeb(url, { w: 1000, h: 1000, language }), 'anonymous');
    }
};

const loadPrivateImage = async (url: string) => {
    const entry = privateImageCache.require(url);
    const result = await entry.promise;
    return await loadDOMImage(result, 'anonymous');
};

export const awaitImageLoad = async (img: HTMLImageElement): Promise<void> => {
    return new Promise<void>((resolve, reject) => {
        img.onload = () => resolve();
        img.onerror = (err) => reject(err);
    });
};